import { render, staticRenderFns } from "./question-itemPartner.vue?vue&type=template&id=adb07ee2&scoped=true"
import script from "./question-itemPartner.vue?vue&type=script&lang=js"
export * from "./question-itemPartner.vue?vue&type=script&lang=js"
import style0 from "./question-itemPartner.vue?vue&type=style&index=0&id=adb07ee2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb07ee2",
  null
  
)

export default component.exports